import { Env } from '/@/Env';
import { MemoryStorage } from '/@/modules/core/app/helpers/MemoryStorage';

export class LocalStorage {
  storage: MemoryStorage | Storage;

  constructor() {
    try {
      this.storage = Env.isServerSideRendering() ? new MemoryStorage() : window.localStorage;
    } catch (e) {
      this.storage = new MemoryStorage();
    }
  }

  getItem(key: string): unknown | undefined {
    const value: unknown = this.storage.getItem(key);

    if (value === 'undefined') {
      return undefined;
    }

    return value;
  }

  removeItem(key: string): boolean | void {
    return this.storage.removeItem(key);
  }

  setItem(key: string, value: unknown): void | Map<string, unknown> {
    if (this.storage instanceof MemoryStorage) {
      return this.storage.setItem(key, value);
    }

    return this.storage.setItem(key, value as string);
  }
}

export default new LocalStorage();
